import React, { PureComponent } from 'react';
import { array, func, bool } from 'prop-types';

// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { createForm } from 'rc-form';
import styled from 'styled-components';
import Collapse from '@material-ui/core/Collapse';

// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { formShape } from 'rc-form';
import InsuranceCarrierInput from './InsuranceCarrierInput';
import InsuranceUploader from './InsuranceUploader';
import { TOUCH_BACK, TOUCH_FRONT } from '../../constants/index';
import history from '../../core/history';
import Button, { ButtonVariations } from '../SolvPatternLibrary/Button';
import { isEmptyString } from '../../core/util/string';
import { colors } from '../../constants/colors';
import { fontSize, fontFamily } from '../../constants/text';
import { isEmpty } from '../../core/util/empty';
import InsuranceCardShape from '../../shapes/InsuranceCard';
import { analyticsTrackEvent } from '../../core/analytics';

const Root = styled.form`
  padding: 30px 0;
  text-align: center;
  margin: 0 auto;
`;

const Header = styled.h1`
  color: ${colors.squid};
  font-family: ${fontFamily.bold};
  font-style: ${fontSize.extraLarge};
  padding: 10px 0;
`;

const Spacing = styled.div`
  padding: 20px 0;
`;

const Action = styled(Button)`
  display: block;
  width: 328px;
  height: 44px;
  padding: 0;
  font-size: ${fontSize.default};
  margin: 0 auto 10px;
`;

type Props = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  fetchMarketplaceInsurers?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  clearData?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'array' refers to a value, but is being used as a ... Remove this comment to see the full error message
  marketplaceInsurers?: array;
  // @ts-expect-error ts-migrate(2749) FIXME: 'bool' refers to a value, but is being used as a t... Remove this comment to see the full error message
  showSkipCopy?: bool;
  // @ts-expect-error ts-migrate(2749) FIXME: 'InsuranceCardShape' refers to a value, but is bei... Remove this comment to see the full error message
  insuranceCard?: InsuranceCardShape;
  passThrough?: string;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  submitInsuranceInformation?: func;
  location?: object;
  // @ts-expect-error ts-migrate(2749) FIXME: 'array' refers to a value, but is being used as a ... Remove this comment to see the full error message
  insurers?: array;
  initialValues?: object;
  currentUser?: object;
  addInsuranceFlow?: string;
  form: formShape;
  requestedInsurance?: object;
  onClickFront: (...args: any[]) => any;
  onClickBack: (...args: any[]) => any;
};

type State = any;

class AddInsurance extends PureComponent<Props, State> {
  state = {
    showInsuranceCardInput: !isEmpty(this.props.requestedInsurance),
    open: true,
  };

  componentDidMount = () => {
    this.props.fetchMarketplaceInsurers();
    this.props.clearData();
  };

  onDropDownChange = (value: any) => {
    this.setState({ showInsuranceCardInput: !isEmptyString(value) });
  };

  submitForm = (e: any) => {
    e && e.preventDefault();

    const {
      submitInsuranceInformation,
      location,
      insurers,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'cardIds' does not exist on type 'object ... Remove this comment to see the full error message
      initialValues: { cardIds = {} },
      currentUser,
      addInsuranceFlow,
    } = this.props;

    const values = this.props.form.getFieldsValue();
    submitInsuranceInformation(
      addInsuranceFlow,
      { ...values, cardFront: cardIds.front, cardBack: cardIds.back },
      location,
      currentUser,
      insurers,
      'dental'
    );
    // @ts-expect-error ts-migrate(2769) FIXME: Type 'undefined' is not assignable to type 'Locati... Remove this comment to see the full error message
    history.push(this.props.passThrough);
  };

  handleSkip = () => {
    // @ts-expect-error ts-migrate(2769) FIXME: Type 'undefined' is not assignable to type 'Locati... Remove this comment to see the full error message
    history.push(this.props.passThrough);
  };

  handleTouch = (type: any) => () => {
    const { addInsuranceFlow } = this.props;
    analyticsTrackEvent(type, { addInsuranceFlow });
  };

  isButtonDisabled = () =>
    !this.state.showInsuranceCardInput ||
    (this.props.insuranceCard.front.scanStarted && !this.props.insuranceCard.front.scanCompleted) ||
    (this.props.insuranceCard.back.scanStarted && !this.props.insuranceCard.back.scanCompleted);

  render() {
    const { form, marketplaceInsurers, showSkipCopy } = this.props;
    const { showInsuranceCardInput } = this.state;

    return (
      <Root onSubmit={this.submitForm}>
        <Header>Add Dental Insurance</Header>

        <InsuranceCarrierInput
          form={form}
          initialValue={this.props.requestedInsurance}
          marketplaceInsurers={marketplaceInsurers}
          onChange={this.onDropDownChange}
          placement="Account - Add Insurance"
        />

        <Spacing>
          <Collapse in={showInsuranceCardInput} timeout="auto">
            <InsuranceUploader
              {...this.props}
              // @ts-expect-error ts-migrate(2769) FIXME: Property 'handleSkip' does not exist on type 'Intr... Remove this comment to see the full error message
              handleSkip={this.handleSkip}
              onClickBack={this.handleTouch(TOUCH_BACK)}
              onClickFront={this.handleTouch(TOUCH_FRONT)}
            />
          </Collapse>
        </Spacing>

        <Action
          disabled={this.isButtonDisabled()}
          type="submit"
          variation={ButtonVariations.pinkPrimary}
        >
          Save
        </Action>

        <Action
          data-testid="insuranceFormSkipBtn"
          onClick={this.handleSkip}
          variation={ButtonVariations.link}
        >
          {showSkipCopy ? 'Skip' : 'Cancel'}
        </Action>
      </Root>
    );
  }
}

export default createForm()(AddInsurance);
